module.exports = "/_next/static/images/32f3a319e62714b97fe36b2b131a7522-apple-pay-md.png.webp";